import type { MatomoHelper } from '@/types/helper/matomo';
import { trackEvent, trackSearchEvent } from './tracking/events';
import { trackViaHTTPApi } from './tracking/http-api';
import { trackPageView } from './tracking/page-view';
import { getVisitorId } from './visitor-id';

/**
 * Matomo helper object for tracking analytics events.
 */
const matomoHelper: MatomoHelper = {
  getVisitorId,
  trackViaHTTPApi,
  trackPageView,
  trackEvent,
  trackSearchEvent,
};

export default matomoHelper;
